var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/hooks/useSearch.tsx";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.values.js";
import { useEffect } from 'react';
import { useStore } from 'effector-react';
import { autofocus$ } from "../extensions/extensionManager";
import { isEmpty } from "../utils";
export function useSearch(_ref) {
  var resetSearchNodes = _ref.resetSearchNodes,
      resetSelected = _ref.resetSelected,
      focus = _ref.focus,
      isolate = _ref.isolate,
      selectedElements = _ref.selectedElements,
      selectViewerElements = _ref.selectViewerElements,
      resetView = _ref.resetView,
      selectElements = _ref.selectElements,
      findElementFromViewer = _ref.findElementFromViewer;
  var autofocus = useStore(autofocus$);
  useEffect(function () {
    if (autofocus && !isEmpty(selectedElements) && isEmpty(selectViewerElements) && Object.values(selectViewerElements).every(function (extId) {
      return extId.length === 1;
    })) {
      focus(selectedElements);
      isolate(selectedElements);
      findElementFromViewer(selectedElements);
    }
  }, [autofocus, findElementFromViewer, focus, isolate, selectViewerElements, selectedElements]);
  useEffect(function () {
    var subscription = resetSearchNodes.watch(function () {
      resetView();
      resetSelected();
    });
    return function () {
      subscription.unsubscribe();
    };
  }, [resetSearchNodes, resetSelected, resetView]);
  useEffect(function () {
    if (!isEmpty(selectViewerElements)) {
      focus(selectViewerElements);
      isolate(selectViewerElements);
      selectElements(selectViewerElements);
    }
  }, [focus, isolate, selectElements, selectViewerElements]);
}